import React from 'react'
import {isPreviewing, isEditing} from '@builder.io/sdk-react'
import {useFetchBuilderReference} from '@/builder/hooks/useFetchBuilderReference'
import {ImageTextCarouselProps, ImageTextItemProps} from './types'

const ImageTextCarouselItem: React.FC<ImageTextItemProps> = ({
    image,
    text,
    ctaText,
    link,
    external,
    external_link,
    contentType
}) => {
    // Determine the URL to use based on whether it's an external link or not

    const urlLink = external
        ? external_link?.value?.data?.url ?? '#'
        : link?.value?.data?.url ?? '#'

    return (
        <div
            className={`image-text-carousel-item mx-auto text-center p-[6px] ${
                contentType === 'grid'
                    ? 'max-w-[120px] lg:max-w-[140px] xl:min-w-[130px]'
                    : 'max-w-[140px] min-w-[140px]'
            }`}
        >
            <a
                href={urlLink}
                target={external ? '_blank' : '_self'}
                rel="noreferrer"
                className="flex flex-col gap-xs items-center"
            >
                {image && (
                    <img
                        src={image}
                        alt={text ? text : 'Image Text Carousel Item'}
                        className={`image-text-carousel-image object-contain ${
                            contentType === 'icons'
                                ? ' w-[72px] h-[72px]'
                                : contentType === 'grid'
                                ? 'w-[70px] h-[70px] lg:w-[70px] lg:h-[70px] xl:w-[90px] xl:h-[90px]'
                                : 'max-w-[101px] lg:max-w-[134px]'
                        }`}
                    />
                )}
                {text && (
                    <p className="image-text-carousel-text leading-[1.2] text-wrap text-[12px] lg:text-[14px] xl:text-[16px] text-emphasis font-grotesque font-medium">
                        {text}
                    </p>
                )}
                {ctaText && <span className="image-text-carousel-cta">{ctaText}</span>}
            </a>
        </div>
    )
}

export default ImageTextCarouselItem
